// TotalBatches.jsx
import React from 'react';
import {
  BatchesCard,
  IconBox,
  TextBlock,
  Value,
} from './styles';
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const BatchesWidget = ({
  bgColor,
  iconBg,
  icon: Icon,      // rename so we can render it
  label,
  quantity,
  qtyColor,
  ctaHref,
  ctaText = 'View in Inventory',
}) => (
  <BatchesCard sx={{ backgroundColor: 'white' }}>
    <IconBox sx={{ backgroundColor: bgColor, display:'flex', justifyContent:'center', alignItems:'center' }}>
      {Icon && <Icon sx={{ fontSize: 24, color: 'white' }} />}
    </IconBox>

    <TextBlock>
      <Typography variant="subtitle2">{label}</Typography>
      <Value>{quantity}</Value>
      <Button component={RouterLink} to={ctaHref} sx={{
  fontSize: 13,
  fontWeight: 600,
  textDecoration: 'none',
  textTransform:'capitalize',
  width:'35px',
  minWidth:0,
  padding:'0',
  '&:hover': { textDecoration: 'underline', backgroundColor: 'transparent',  // keep same color
      boxShadow: 'none', },}}>{ctaText}</Button>
    </TextBlock>
  </BatchesCard>
);

export default BatchesWidget;
